type Props = {
  onLocate: (lat: number, lon: number) => void
  onError: (msg: string) => void
}

export function HereButton({ onLocate, onError }: Props) {
  const handle = () => {
    if (!navigator.geolocation) {
      onError("Geolokalizacja nieobsługiwana w tej przeglądarce")
      return
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => onLocate(pos.coords.latitude, pos.coords.longitude),
      (err) => {
        if (err.code === err.PERMISSION_DENIED) {
          onError("Brak dostępu do lokalizacji — przewiń mapę ręcznie")
        } else if (err.code === err.TIMEOUT) {
          onError("Nie udało się pobrać lokalizacji")
        } else {
          onError("Błąd geolokalizacji")
        }
      },
      { enableHighAccuracy: true, timeout: 10_000 },
    )
  }
  return (
    <button className="fab here" onClick={handle} aria-label="Tu jestem — pokaż moją lokalizację">
      📍 Tu jestem
    </button>
  )
}
